
import viewer from './viewer';
import ar from './ar';
import vr from './vr';

const config = {
    viewer,
    ar,
    vr
};

export default config;